// GfxRender.js


import { Transform } from "../../VectorUtilsJS/src/VectorUtilLib.js";
import { GfxPath } from "../../GfxContainer/src/GfxDrawing.js";
import { GenerateDXF, GenerateSVG } from "../../VectorUtilsJS/src/VectorFileLib.js";
import { BasicUnits } from "../../VectorUtilsJS/src/VectorUtilLib.js";


//-------------------------------------------------------------------------------------
//	View Transform Utilities
//-------------------------------------------------------------------------------------

var GfxRender = (function() {

	// Default SVG namespace for embedded data
	var SVG_Namespace = { CompanyName: "CompanyName", AppName: "AppName", DataName: "DataName", DataId: "DataId" };

	var RenderGfxDrawing = function(context, gfxDrawing, viewTransform)
	{
		var pathCount = gfxDrawing.GetPathCount();
		
		for (var pathIdx = 0; pathIdx < pathCount; pathIdx++)
		{
			let gfxPath = gfxDrawing.GetGfxPath(pathIdx);
			let gfxSettings = gfxDrawing.GetPathSettings(pathIdx);
			
			if (gfxSettings.strokePath)
			{
				context.strokeStyle = gfxSettings.strokeColor;
				context.lineWidth = viewTransform.scaleNum(gfxSettings.strokeWidth);
			}
			
			if (gfxSettings.fillPath)
			{
				context.fillStyle = gfxSettings.fillColor;
			}
			
			RenderGfxPath(context, gfxPath, viewTransform, {strokePath:gfxSettings.strokePath, fillPath:gfxSettings.fillPath} );
		}
	}
	
	
	var RenderGfxPath = function(context, gfxPath, viewTransform, actions = { strokePath: true })
	{
		context.beginPath();
	
		for (var i = 0; gfxPath != undefined && i < gfxPath.GetOpCount(); i++)
		{
			let op = gfxPath.GetOp(i);
			
			if (op.op == GfxPath.Op.NOOP)
			{
			}
			else if (op.op == GfxPath.Op.MOVETO)
			{
				MoveTo(context, op.pt, viewTransform);
			}
			else if (op.op == GfxPath.Op.LINETO)
			{
				LineTo(context, op.pt, viewTransform);
			}
			else if (op.op == GfxPath.Op.ARC)
			{
				Arc(context, op.pt, op.r, op.start, op.end, op.ccw, viewTransform);
			}
			else if (op.op == GfxPath.Op.CIRCLE)
			{
				Circle(context, op.pt, op.r, viewTransform);
			}
			else if (op.op == GfxPath.Op.CLOSE)
			{
				context.closePath();
			}
			else if (op.op == GfxPath.Op.TEXT)
			{
				Text(context, op.pt, op.str, viewTransform);
			}
		}
	
		if (actions.fillPath)
			context.fill();
	
		if (actions.strokePath)
			context.stroke();
	}

	var RenderGfxPathDebug = function(context, gfxPath, viewTransform)
	{
		let st = context.fillStyle;
		context.fillStyle = "red";
		
		// Draw only the points for the operations
		for (var i = 0; gfxPath != undefined && i < gfxPath.GetOpCount(); i++)
		{
			let sz = 5;
			let op = gfxPath.GetOp(i);
		
			if (op.op == GfxPath.Op.MOVETO || op.op == GfxPath.Op.LINETO||op.op == GfxPath.Op.ARC || op.op == GfxPath.Op.CIRCLE)
			{
				var xpt = (viewTransform != undefined) ? viewTransform.xfrm(op.pt) : op.pt;
				context.fillRect(xpt.x - sz/2, xpt.y - sz/2, sz, sz);
			}
		}
		context.fillStyle = st;
	}

	var MoveTo = function(context, pt, xform)
	{
		var xpt = (xform != undefined) ? xform.xfrm(pt) : pt;
		context.moveTo(xpt.x, xpt.y);
	}

	var LineTo = function(context, pt, xform)
	{
		var xpt = (xform != undefined) ? xform.xfrm(pt) : pt;
		context.lineTo(xpt.x, xpt.y);
	}

	var Arc = function(context, pt, radius, startAngle, endAngle, ccw, xform)
	{
		var xpt = (xform != undefined) ? xform.xfrm(pt) : pt;
		var xr  = (xform != undefined) ? xform.scaleNum(radius) : radius;
		context.arc(xpt.x, xpt.y, xr, startAngle, endAngle, ccw);
	}
	
	var Circle = function(context, pt, radius, xform)
	{
		var xpt = (xform != undefined) ? xform.xfrm(pt) : pt;
		var xr  = (xform != undefined) ? xform.scaleNum(radius) : radius;
		context.moveTo(xpt.x + xr, xpt.y);
		context.arc(xpt.x, xpt.y, xr, 0, 2 * Math.PI);
	}
	
	var Text = function(context, pt, str, xform)
	{
		var xpt = (xform != undefined) ? xform.xfrm(pt) : pt;
		//let s = context.fillStyle;
		//context.fillStyle = "#0000FF";
		context.font = '24px sans-serif';
		context.fillText(str, xpt.x, xpt.y);
		//context.fillStyle = s;
	}
	
	//-------------------------------------------------------------------------------------
	//	Generate SVG
	//-------------------------------------------------------------------------------------
	var RenderGfxDrawingToSVG = function(gfxDrawing, gfxAppData)
	{
		var b = gfxDrawing.FindBounds();
		var offsetX = -b.min.x;
		var offsetY = -b.min.y;
		var exportW = b.max.x - b.min.x;
		var exportH = b.max.y - b.min.y;
			
		GenerateSVG.Start(exportW, exportH, BasicUnits.MILLIMETERS);
		GenerateSVG.SetInvertVertical(false);
		GenerateSVG.SetOffset(offsetX, offsetY);
		
		GenerateSVG.StartGroup({label:{name:"Layer 1", id:"layer1"}});

		var pathCount = gfxDrawing.GetPathCount();
		
		for (var pathIdx = 0; pathIdx < pathCount; pathIdx++)
		{
			let gfxPath = gfxDrawing.GetGfxPath(pathIdx);
			let gfxSettings = gfxDrawing.GetPathSettings(pathIdx);
			
			GenerateSVG.SetFillInfo(gfxSettings.fillPath, gfxSettings.fillColor);
			GenerateSVG.SetStrokeInfo(gfxSettings.strokePath, gfxSettings.strokeColor, gfxSettings.strokeWidth);
			GenerateSVG.AddGfxPath(gfxPath);
		}
	
		GenerateSVG.EndGroup(); // 2019.02.15
		
		if (gfxAppData != undefined)
		{
			var privateDataStr = JSON.stringify(gfxAppData);

			GenerateSVG.SetPrivateNamespace(SVG_Namespace.CompanyName, SVG_Namespace.AppName, SVG_Namespace.DataName);
			GenerateSVG.EmbedPrivateData(SVG_Namespace.DataId, privateDataStr);
		}

		var svg = GenerateSVG.Finish();

		return svg;
	}

	//-------------------------------------------------------------------------------------
	//	SetSVGNamespace
	//-------------------------------------------------------------------------------------
	var SetSVGNamespace = function(companyName, appName, dataName, dataId)
	{
		SVG_Namespace.CompanyName = companyName;
		SVG_Namespace.AppName = appName;
		SVG_Namespace.DataName = dataName;
		SVG_Namespace.DataId = dataId;
	}
	
	//-------------------------------------------------------------------------------------
	//	API
	//-------------------------------------------------------------------------------------
	return {
		RenderGfxPath:			RenderGfxPath,
		RenderGfxDrawing:		RenderGfxDrawing,
		MoveTo:					MoveTo,
		LineTo:					LineTo,
		Arc:					Arc,
		Circle:					Circle,
		Text:					Text,
		RenderGfxDrawingToSVG:	RenderGfxDrawingToSVG,
		SetSVGNamespace:		SetSVGNamespace
	};
}());



//-------------------------------------------------------------------------------------
//	Public
//-------------------------------------------------------------------------------------
export { GfxRender };

